export const getDOBFormatted = (date: string) => {
  try {
    return new Date(date).toISOString();
  } catch (e) {
    console.log(e);
    return '';
  }
};
